module.exports = __webpack_public_path__ + "img/piecepatternfrench.15c6c0f5.png";